export default __webpack_public_path__ + "static/MinorityAndWomen-OwnedBusinessResources-142f7c38241b31ef31cc0d3d3f8456c4.jpg";